import React from "react";
import PropTypes from "prop-types";

// Utilities
import kebabCase from "lodash/kebabCase";

// Components
import Helmet from "react-helmet";
import Link from "gatsby-link";

const NotFoundPage = ({
  data: { allMarkdownRemark: { group }, site: { siteMetadata: { title } } },
}) => (
  <div className="pageContainer">
    <Helmet title={title} />
    <div className="blog-list-container static-page">
      <h1 style={{color:"grey"}}>Error 404</h1>
      <h3>Ésta no es la página que buscabas...</h3>
      <p>¡No te preocupes! puedes <Link to="/blog"> volver al blog </Link> o clickar en los siguientes temas para encontrar contenido del bueno: </p>
      <ul className="tag-list">
        {group.map(tag => (
          <li key={tag.fieldValue}>
            <Link to={`/blog/etiquetas/${kebabCase(tag.fieldValue)}/`}>
              {tag.fieldValue} ({tag.totalCount})
            </Link>
          </li>
        ))}
      </ul>
    </div>
  </div>
);

NotFoundPage.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      group: PropTypes.arrayOf(
        PropTypes.shape({
          fieldValue: PropTypes.string.isRequired,
          totalCount: PropTypes.number.isRequired,
        }).isRequired
      ),
    }),
    site: PropTypes.shape({
      siteMetadata: PropTypes.shape({
        title: PropTypes.string.isRequired,
      }),
    }),
  }),
};

export default NotFoundPage

export const pageQuery = graphql`
  query TagsErrorQuery {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(
      limit: 2000
    ) {
      group(field: frontmatter___tags) {
        fieldValue
        totalCount
      }
    }
  }
`;





// WEBPACK FOOTER //
// ./src/pages/404.js